export default "__VITE_ASSET__DBIYNTZ7__"